import React, { Component } from 'react';
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { MyPATLink } from '../../common';
import _ from 'lodash';
import cx from 'classnames';
import {
    ArrowBackOutlined as BackIcon,
} from '@material-ui/icons';
import WithContent from './WithContent';
import { showMsg } from '../actions/loaderAlert';
import { usersList } from '../../mylibrary/actions/userActions';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { styles } from '../styling/CourseDetail';
import courseService from "../services/courseService";

interface ArchivedCourseProps extends WithStyles<typeof styles> {
    showMsg: (msg: string, vari: string) => void,
    usersList: () => void,
}

interface ArchivedCourseStates {
    archiveList: [];
}

class ArchivedCourse extends Component<ArchivedCourseProps, ArchivedCourseStates> {
    constructor(props: ArchivedCourseProps) {
        super(props);

        this.state = {
            archiveList: [],
        }
    }
    componentDidMount() {
        courseService.getCourseData("Archive=true")
            .then((res: any) => {
                if(res.length){
                    this.setState({ archiveList: res }) 
                    this.props.showMsg("All Archived Courses Listed!", 'success');  
                }
                else{
                    this.props.showMsg("No Archived Courses!", 'success');  
                }
            });
    }

    render() {
        const { classes } = this.props;
        const { archiveList } = this.state;

        const Content = archiveList.length ? <WithContent courseListingData={archiveList} isArchived={true} /> : ""

        return (
            <>
                <Grid container
                    spacing={0}
                    direction="column"
                    className={classes.root}>
                    <Grid
                        xs={8}
                        style={{ padding: "10px 168px" }} >

                        <MyPATLink to={`/course/`}>
                            <BackIcon style={{ fontSize: "21px", verticalAlign: "sub", color: "#000000" }} />
                            <Typography style={{ fontSize: "19px", paddingLeft: "40px", display: "inline-block" }}>Archived Courses</Typography>
                        </MyPATLink>
                    </Grid>

                </Grid>
                {Content}
            </>
        )
    }
}
const mapStateToProps = (state: any) => ({
    courseData: state.courseData.courseData.list
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        showMsg: showMsg,
        usersList,
    },
    dispatch
);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ArchivedCourse));